import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import { Heading, Hr, Text } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import { Containers } from '@grandvisionhq/stores-v2';
import { AppointmentConfirmationInstructionsContainer } from '../../../../components/AppointmentConfirmationInstructions/AppointmentConfirmationInstructionsContainer.js';
import '../../../../components/AppointmentConfirmation/AppointmentConfirmation.js';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '@grandvisionhq/utils';
import '../../../BookAppointment/context/appointment-slots.js';
import '@grandvisionhq/graphql';
import '../../../BookAppointment/queries/get-book-appointment-store-by-id.js';
import '../../../BookAppointment/queries/get-book-appointment-type.js';
import '@grandvisionhq/bloomreach';
import '../../../../queries/get-availability-stores-nearby.js';
import 'date-fns';
import '@grandvisionhq/icons';
import '../../../../components/NoTimeSlots/types.js';
import '../../../../components/StoreFinder/StoreFinderContainer.js';
import AppointmentOverview from '../../../../components/AppointmentOverview/AppointmentOverview.js';
import '../../../../context/WhatStepSlotContext/WhatStepSlotContext.js';
import '@grandvisionhq/forms';
import '@grandvisionhq/lib-utils-html';
import '../../../../components/Navigation/steps.js';
import '@grandvisionhq/auth';
import ICSButton from '../../../../components/ICSButton/ICSButton.js';
import '@grandvisionhq/locations';
import StoreOverviewContainer from '../../../../components/StoreOverview/StoreOverviewContainer.js';
import UserInfoOverviewContainer from '../../../../components/UserInfoOverview/UserInfoOverviewContainer.js';

const StoreOffers = Containers.StoreOffers;
const RescheduleAppointmentConfirmation = (_param)=>{
    var { className , labels , appointment , store , offers , timeSlot , storesUrl , directionsUrl , googleMapsApiKey , returnPath , returnLabel , appointmentConfirmationContent , offerFallbackImageUrl , isVirtualAppointmentType , onICSButtonClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "appointment",
        "store",
        "offers",
        "timeSlot",
        "storesUrl",
        "directionsUrl",
        "googleMapsApiKey",
        "returnPath",
        "returnLabel",
        "appointmentConfirmationContent",
        "offerFallbackImageUrl",
        "isVirtualAppointmentType",
        "onICSButtonClick"
    ]);
    var ref, ref1, ref2, ref3;
    const { id , appointmentType , startTime , endTime , isReservation  } = appointment;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('reschedule-appointment-confirmation', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "small",
        className: "cancel-appointment-confirmation__title"
    }, labels.title), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(Text, null, labels.confirmation), /*#__PURE__*/ React.createElement(Alert, {
        variant: "success",
        title: labels.notification,
        className: "alert-m-default reschedule-appointment-confirmation__alert"
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.subtitle), /*#__PURE__*/ React.createElement("div", {
        className: "reschedule-appointment-confirmation__appointment_overview_wrapper"
    }, /*#__PURE__*/ React.createElement(AppointmentOverview, {
        className: "reschedule-appointment-confirmation__appointment_overview",
        appointment: {
            id,
            appointmentType,
            startTime,
            endTime
        },
        labels: labels
    }, appointment.customerComment && /*#__PURE__*/ React.createElement(Text, {
        className: "reschedule-appointment-confirmation__customer-comment"
    }, labels.additionalInformation, ": ", appointment.customerComment)), store && appointmentType && timeSlot && !isReservation && /*#__PURE__*/ React.createElement(ICSButton, {
        caption: labels.addToCalendar,
        appointmentType: appointmentType,
        timeSlot: timeSlot,
        store: store,
        variant: "outline",
        className: "reschedule-appointment-confirmation__button",
        onClick: onICSButtonClick
    })), !isVirtualAppointmentType && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.where), store && /*#__PURE__*/ React.createElement(StoreOverviewContainer, {
        store: store,
        googleMapsApiKey: googleMapsApiKey,
        storesUrl: storesUrl
    })), directionsUrl && /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        hrefTarget: "_blank",
        href: directionsUrl,
        caption: labels.getDirections,
        className: "reschedule-appointment-confirmation__button reschedule-appointment-confirmation__button--get-direction"
    }), !isReservation && appointmentConfirmationContent && /*#__PURE__*/ React.createElement(AppointmentConfirmationInstructionsContainer, {
        confirmationContent: appointmentConfirmationContent
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.who), /*#__PURE__*/ React.createElement(UserInfoOverviewContainer, {
        user: {
            firstName: (ref = appointment.invitee) === null || ref === void 0 ? void 0 : ref.firstName,
            lastName: (ref1 = appointment.invitee) === null || ref1 === void 0 ? void 0 : ref1.lastName,
            email: (ref2 = appointment.invitee) === null || ref2 === void 0 ? void 0 : ref2.email,
            phone: (ref3 = appointment.invitee) === null || ref3 === void 0 ? void 0 : ref3.phone,
            child: appointment.child
        }
    }), !isReservation && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.cantMakeIt), /*#__PURE__*/ React.createElement(Text, null, labels.confirmationEmailInstruction)), !isReservation && offers && offers.length > 0 && /*#__PURE__*/ React.createElement(StoreOffers, {
        className: "reschedule-appointment-confirmation__store-offers",
        fallbackImage: offerFallbackImageUrl,
        offers: offers,
        linkTarget: "_blank"
    }), /*#__PURE__*/ React.createElement(Button, {
        caption: returnLabel,
        href: returnPath,
        variant: "outline",
        className: "reschedule-appointment-confirmation__button reschedule-appointment-confirmation__button--close"
    }));
};

export { RescheduleAppointmentConfirmation as default };
//# sourceMappingURL=RescheduleAppointmentConfirmation.js.map
